import { useMemo } from 'react';

import { useTranslation } from '@cx-modules/i18n-provider';

import { getFooterNotice, getPoweredBy } from '../utils/labels';

import { type GroupedOffersResult } from './useGroupedOffers';

interface UseTabContainerAdornments {
  analyticsDataLayer?: unknown[] | undefined;
  disableAnalytics: boolean;
  footerNotice?: string;
  fullPageUrl: string;
  geolocation?: string;
  hasMultipleCategories: boolean;
  poweredBy?: string;
  sortedGroupedOffers: GroupedOffersResult;
}

export const useTabContainerAdornments = ({
  analyticsDataLayer,
  disableAnalytics,
  footerNotice,
  fullPageUrl,
  geolocation,
  hasMultipleCategories,
  poweredBy,
  sortedGroupedOffers,
}: UseTabContainerAdornments) => {
  const { t } = useTranslation();

  const headerTitle = useMemo(() => {
    if (geolocation === 'ca-on') {
      return ''; // Deliberately empty for legal reasons in Ontario
    }

    if (hasMultipleCategories) {
      return t('CX_OFFERS_HEADER_TITLE', { defaultValue: 'Offers' });
    }

    return sortedGroupedOffers?.[0]?.[0]?.translatedCategory ?? '';
  }, [geolocation, hasMultipleCategories, sortedGroupedOffers, t]);

  const footerNoticeContents = getFooterNotice(footerNotice);

  const poweredByContents = getPoweredBy({
    analyticsDataLayer,
    disableAnalytics,
    fullPageUrl,
    poweredBy,
  });

  return {
    footerNoticeContents,
    headerTitle,
    poweredByContents,
  };
};
